
;
define("common/singletonviewmodel", function(){});

